import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const API_URL =
  process.env.NODE_ENV === "production"
    ? (process.env.REACT_APP_API_URL || "https://api.hellastay.com")
    : "http://localhost:8000";

export default function Verify() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) return;

    fetch(`${API_URL}/api/verify`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    })
      .then((res) => res.json())
      .then((data) => alert(data.message))
      .catch(() => alert("Verification failed"));
  }, [token]);

  return (
    <div className="page">
      <h1>Email Verification</h1>
      <p>Processing...</p>
    </div>
  );
}
